<template>
  <section
    class="bg-ontick-graphite-500 z-20 flex h-14 items-center shadow-lg lg:hidden"
  >
    <transition
      enter-active-class="transform-gpu transition ease-in-out duration-500 sm:duration-700"
      enter-class="translate-y-full"
      enter-to-class="translate-y-0"
      leave-active-class="transform-gpu transition ease-in-out duration-500 sm:duration-700"
      leave-class="translate-y-0"
      leave-to-class="translate-y-full"
    >
      <div
        v-show="active_details"
        class="bg-ontick-graphite-500 absolute bottom-12 w-full"
      >
        <notification-component
          :active="active_notification"
          @notifications="qtdNotications"
        />
        <menu-user
          :user="user_name"
          :user_picture="user_picture"
          :user_code="user_code"
          :openMenuNavbar="active_user"
        />

        <account-mobile
          :active="active_account"
          @close="active_account = false"
        />
        <div class="border-ontick-carbon-500 flex border">
          <a
            href="https://ajuda.ontick.com.br"
            target="_blank"
            class="buttons_details text-ontick-blue-600 demo:text-gray-400"
          >
            <span v-html="$icons.help"></span>
          </a>
          <a
            @click="active_user = !active_user"
            v-click-outside="activeUser"
            class="buttons_details relative z-10"
            :class="
              active_user
                ? 'text-ontick-blue-600'
                : 'text-ontick-blue-600 demo:text-gray-400'
            "
          >
            <span v-html="$icons.profile"></span>

            <ontick-alert-badge
              class="top-1 right-4"
              v-if="hasUnreadMessages"
            />
          </a>
          <button
            @click="active_notification = !active_notification"
            v-click-outside="activeNotification"
            type="button"
            :class="
              active_notification
                ? 'text-ontick-blue-600'
                : 'text-ontick-blue-600 demo:text-gray-400'
            "
            class="buttons_details"
          >
            <span v-html="$icons.bell"></span>

            <span
              v-show="notification.length > 0"
              class="bg-ontick-green-500 text-ontick-graphite-500 ring-ontick-green-500 absolute top-0 right-0 -mt-0 -ml-2 block h-4 w-4 rounded-full text-xs font-medium ring-2"
              >{{ notification.length }}</span
            >
          </button>
          <button class="px-6" @click="active_account = true">
            <div
              class="h-6 w-6 text-gray-50"
              v-html="itemLogo(accountTypes.selectedAccount.broker_name)"
            ></div>
          </button>
        </div>
      </div>
    </transition>

    <div class="bg-ontick-graphite-500 relative flex w-full">
      <swiper
        class="flex w-full items-center justify-between"
        :options="options"
      >
        <swiper-slide v-for="item in nav" :key="item.title">
          <router-link
            v-if="item.visible"
            :to="item.url"
            class="inline-block w-full items-center pt-2 pb-1 text-center"
          >
            <div class="inline-block justify-center">
              <div>
                <span
                  class="inline-block"
                  :class="[
                    $route.path == item.url
                      ? 'text-ontick-blue-500'
                      : 'text-gray-400',
                    {
                      'h-6 w-6 translate-y-[-2px] transform':
                        item.title === 'Ranking',
                    },
                    {
                      'h-5 w-5 ': item.title !== 'Ranking',
                    },
                  ]"
                  v-html="item.icon"
                ></span>

                <span
                  :class="[
                    $route.path == item.url ? 'text-white' : 'text-gray-400',
                    {
                      'translate-y-[-4px] transform': item.title === 'Ranking',
                    },
                  ]"
                  class="block whitespace-nowrap text-center text-[10px]"
                  >{{ item.truncatedTitle || item.title }}</span
                >
              </div>
            </div>
          </router-link>
        </swiper-slide>
        <swiper-slide>
          <button
            v-if="getExtensions"
            @click="partnerTabIsActive = !partnerTabIsActive"
            class="inline-block w-full items-center pt-2 pb-1 text-center"
          >
            <div class="inline-block justify-center">
              <div>
                <span
                  class="inline-block h-5 w-5 text-gray-400"
                  v-html="$icons.person_check"
                ></span>

                <span
                  class="block whitespace-nowrap text-center text-[10px] text-gray-400"
                >
                  Parceiros ativados
                </span>
              </div>
            </div>
          </button>
        </swiper-slide>
      </swiper>
      <a
        @click="active_details = !active_details"
        class="w-18 bg-ontick-graphite-500 z-20 inline-block justify-center px-3 pt-2 pb-1 text-center"
        style="filter: drop-shadow(-3px 0px 2px rgba(0, 0, 0, 0.2))"
      >
        <i
          v-html="$icons.nav_kebab"
          class="inline-block h-6 w-6"
          :class="active_details ? 'text-ontick-blue-500' : 'text-gray-400'"
        ></i>

        <span
          :class="active_details ? 'text-white' : 'text-gray-400'"
          class="tab tab-home block text-[10px]"
        >
          Opções
        </span>
      </a>
    </div>
    <portal to="modal">
      <transition name="slide">
        <nav
          class="bg-ontick-carbon-500 fixed inset-0 z-20 flex flex-col gap-6 overflow-y-auto px-6 pt-12 pb-24"
          v-if="partnerTabIsActive"
        >
          <span class="font-semibold"> Parceiros ativados </span>
          <ul>
            <li
              v-for="extension in getExtensions"
              :key="extension.extensions[0].extension_id"
              @click="partnerTabIsActive = false"
            >
              <router-link
                class="flex items-center space-x-4 py-2"
                :to="{
                  name: 'Estratégias de parceiro',
                  params: {
                    partner_name: extension.extension_path,
                    extension_id: extension.extensions[0].extension_id,
                  },
                }"
              >
                <img
                  :src="extension.extension_logo"
                  :alt="extension.extension_owner"
                  class="h-5 w-5"
                />
                <span>
                  {{ extension.extension_owner }}
                </span>
              </router-link>
            </li>
          </ul>
        </nav>
      </transition>
    </portal>
  </section>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import ClickOutside from "vue-click-outside";
import NotificationComponent from "@/app/modules/notification/components/notification-mobile.component.vue";
import AccountMobile from "../../account/account-mobile.component.vue";
import PartnersTabComponent from "../partners-tab.component.vue";

export default {
  directives: {
    ClickOutside,
  },
  props: {
    nav: { type: Array, default: null },
    active: { type: Boolean },
    icon: { type: Object },
    compress_sidebar: { type: Boolean },
  },
  components: {
    Swiper,
    SwiperSlide,
    MenuUser: () => import("../sidebar-menu-user.component.vue"),
    NotificationComponent,
    AccountMobile,
    PartnersTabComponent,
  },
  data() {
    return {
      active_details: false,
      active_user: false,
      active_notification: false,
      active_account: false,
      notification: [],
      options: {
        slidesPerView: 4,
        centeredSlides: false,
        spaceBetween: 10,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      partnerTabIsActive: false,
    };
  },

  computed: {
    ...mapState({
      accountTypes: (state) => state.accountTypes,
      user_name: (state) => state.config.user_name,
      user_picture: (state) => state.config.user_picture,
      user_code: (state) => state.config.user_code,
    }),
    ...mapGetters({
      hasUnreadMessages: "config/hasUnreadMessages",
      getExtensions: "config/getExtensions",
    }),
  },
  methods: {
    activeUser() {
      this.active_user = false;
    },

    activeNotification() {
      this.active_notification = false;
    },

    qtdNotications(value) {
      this.notification = value;
    },
    itemLogo(value) {
      let img;
      if (value == "OnTick") {
        img = this.$icons.ontick;
      } else if (value == "XP") {
        img = this.$icons.xp;
      } else if (value == "Cripto") {
        img = this.$icons.bitcoin;
      }
      return img;
    },
  },
};
</script>

<style lang="scss" scoped>
.buttons_details {
  @apply bg-ontick-graphite-500 hover:bg-ontick-steel-600 demo:hover:text-gray-100 relative inline-flex w-full items-center justify-center px-4 py-3 text-sm font-medium focus:outline-none;
}
.slide {
  &-enter-active,
  &-leave-active {
    @apply transform-gpu transition-all duration-500 ease-in-out;
  }
  &-enter,
  &-leave-to {
    @apply translate-x-full opacity-0;
  }
  &-enter-to,
  &-leave {
    @apply translate-x-0 opacity-100;
  }
}
</style>
